<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="clipboard-type-icon"
    aria-hidden="true"
  >
    <template v-if="type === 'prompt'">
      <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
      <path d="M20 3v4" />
      <path d="M22 5h-4" />
      <path d="M4 17v2" />
      <path d="M5 18H3" />
    </template>
    <template v-else-if="type === 'asin'">
      <line
        x1="4"
        x2="20"
        y1="9"
        y2="9"
      />
      <line
        x1="4"
        x2="20"
        y1="15"
        y2="15"
      />
      <line
        x1="10"
        x2="8"
        y1="3"
        y2="21"
      />
      <line
        x1="16"
        x2="14"
        y1="3"
        y2="21"
      />
    </template>
    <template v-else-if="type === 'gtin'">
      <path d="M3 5v14" />
      <path d="M8 5v14" />
      <path d="M12 5v14" />
      <path d="M17 5v14" />
      <path d="M21 5v14" />
    </template>
    <template v-else>
      <path d="M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8Z" />
      <path d="M15 3v4a2 2 0 0 0 2 2h4" />
    </template>
  </svg>
</template>

<script>
export default {
  name: 'ClipboardTypeIcon',

  props: {
    type: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.clipboard-type-icon {
  flex-shrink: 0;
  color: #6b7280;
}
</style>
